import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f73470e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-20 w-100" }
const _hoisted_2 = { class: "bg-light-green flex-md-row flex-column rounded d-flex align-items-md-center w-100 pdl-20 sm-pdl-5 pdt-25 pdb-25 gap-40" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "sm-pdl-10" }, "Local", -1))
const _hoisted_4 = { class: "d-flex gap-20 w-100 flex-column flex-md-row" }
const _hoisted_5 = { class: "custom-select d-flex flex-row align-items-end gap-15" }
const _hoisted_6 = { class: "d-flex gap-20 w-100 flex-column flex-md-row" }
const _hoisted_7 = { class: "custom-select links" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "body-text" }, " Employer (s) ", -1))
const _hoisted_9 = { class: "custom-select links" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "body-text" }, " Production (s) ", -1))
const _hoisted_11 = { class: "custom-select links" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "body-text" }, " Payor (s) ", -1))
const _hoisted_13 = { class: "d-flex gap-20 flex-column flex-md-row" }
const _hoisted_14 = { class: "custom-select links" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "body-text" }, " Fund (s) ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-select links" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SelectComponent, {
      options: _ctx.savedTemplates,
      singleArrow: true,
      selectedOption: _ctx.selectedTemplate,
      "onUpdate:selectedOption": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTemplate) = $event)),
      customClass: "w-25 w-sm-100",
      hasDefaultOption: false,
      onChange: _ctx.emitChangeTemplate
    }, null, 8, ["options", "selectedOption", "onChange"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_RadioButton, {
        options: _ctx.localTypes,
        name: "LocalType",
        modelValue: _ctx.localFilters.Local,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localFilters.Local) = $event)),
        id: "LocalType",
        onChange: _ctx.emitUpdate,
        customClass: "primary small bold"
      }, null, 8, ["options", "modelValue", "onChange"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_TextInput, {
        type: "text",
        label: "Member's First Name",
        placeholder: "Enter Member's First Name",
        max: 25,
        modelValue: _ctx.localFilters.FirstName,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localFilters.FirstName) = $event)),
        onChange: _ctx.emitUpdate
      }, null, 8, ["modelValue", "onChange"]),
      _createVNode(_component_TextInput, {
        type: "text",
        label: "Member's Last Name",
        placeholder: "Enter Member's Last Name",
        max: 25,
        modelValue: _ctx.localFilters.LastName,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localFilters.LastName) = $event)),
        onChange: _ctx.emitUpdate
      }, null, 8, ["modelValue", "onChange"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_DateInput, {
          label: "Work Period",
          modelValue: _ctx.localFilters.PeriodStart,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localFilters.PeriodStart) = $event)),
          isRequired: true,
          onChange: _ctx.emitUpdate,
          error: _ctx.localErrors.PeriodStart
        }, null, 8, ["modelValue", "onChange", "error"]),
        _createVNode(_component_DateInput, {
          modelValue: _ctx.localFilters.PeriodEnd,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localFilters.PeriodEnd) = $event)),
          onChange: _ctx.emitUpdate,
          error: _ctx.localErrors.PeriodEnd
        }, null, 8, ["modelValue", "onChange", "error"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_Multiselect, {
          modelValue: _ctx.localFilters.Employers,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localFilters.Employers) = $event)),
          placeholder: "Type to search",
          label: "Name",
          "track-by": "ID",
          options: _ctx.employers,
          loading: _ctx.loadingProductions,
          multiple: true,
          "hide-selected": true,
          searchable: true,
          "close-on-select": true,
          onSelect: _ctx.handleEmployersChange,
          onOpen: _ctx.handleEmployersOpen,
          onSearchChange: _ctx.handleEmployersSearch,
          onChange: _ctx.emitUpdate
        }, null, 8, ["modelValue", "options", "loading", "onSelect", "onOpen", "onSearchChange", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_Multiselect, {
          modelValue: _ctx.localFilters.Productions,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localFilters.Productions) = $event)),
          placeholder: "Type to search",
          label: "Name",
          "track-by": "ID",
          options: _ctx.productions,
          multiple: true,
          "hide-selected": true,
          searchable: true,
          "close-on-select": true,
          onSelect: _ctx.handleProductionChange,
          onOpen: _ctx.handleProductionsOpen,
          onSearchChange: _ctx.handleProductionsSearch,
          loading: _ctx.loadingProductions,
          onChange: _ctx.emitUpdate
        }, null, 8, ["modelValue", "options", "onSelect", "onOpen", "onSearchChange", "loading", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_Multiselect, {
          modelValue: _ctx.localFilters.Payors,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localFilters.Payors) = $event)),
          placeholder: "Type to search",
          label: "Name",
          "track-by": "ID",
          options: _ctx.payors,
          multiple: true,
          "hide-selected": true,
          searchable: true,
          "close-on-select": true,
          onSelect: _ctx.handlePayors,
          onOpen: _ctx.handlePayorsOpen,
          onSearchChange: _ctx.handlePayorsSearch,
          onChange: _ctx.emitUpdate
        }, null, 8, ["modelValue", "options", "onSelect", "onOpen", "onSearchChange", "onChange"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_component_Multiselect, {
          modelValue: _ctx.localFilters.Funds,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.localFilters.Funds) = $event)),
          placeholder: "Type to search",
          label: "Name",
          "track-by": "ID",
          options: _ctx.funds,
          multiple: true,
          "hide-selected": true,
          searchable: true,
          "close-on-select": true,
          onSelect: _ctx.handleFunds,
          onSearchChange: _ctx.handleFundsSearch,
          onChange: _ctx.emitUpdate
        }, null, 8, ["modelValue", "options", "onSelect", "onSearchChange", "onChange"])
      ]),
      _createVNode(_component_TextInput, {
        type: "text",
        name: "number",
        label: "Member’s NBF ID / SSN",
        placeholder: "Enter Member’s NBF ID / SSN",
        max: 25,
        modelValue: _ctx.localFilters.PersonID,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.localFilters.PersonID) = $event)),
        onChange: _ctx.emitUpdate
      }, null, 8, ["modelValue", "onChange"]),
      _hoisted_16
    ])
  ]))
}